// Internal Imports
import { ContentList } from './ContentList.jsx';
import { WithLoader } from '../Hoc/WithLoader/WithLoader.jsx';

// Local Variables
const ContentListWithLoader = WithLoader(ContentList);

// Module Exports
export { ContentListWithLoader };
